import { render, staticRenderFns } from "./_tableOrderId.vue?vue&type=template&id=4393bd33&scoped=true"
import script from "./_tableOrderId.vue?vue&type=script&lang=js"
export * from "./_tableOrderId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393bd33",
  null
  
)

export default component.exports